import { sceneConfig } from "../config/scene";
import { qrConfig } from "../config/contact";
import { THREE } from "../dependencies";
import type { Group } from "three";
import { palette } from "../theme";
import { qr, size } from "../contact";
import { destinations } from "./sculpture";

export function createMeshes(world: Group) {
	const starts = [];
	const cell = sceneConfig.qr.width / (size + qrConfig.quietZoneModules * 2);
	for (let y = 0; y < size; y++)
		for (let x = 0; x < size; x++)
			if (qr.isDark(y, x))
				starts.push({
					x: (x - (size - 1) / 2) * cell,
					z: (y - (size - 1) / 2) * cell,
				});
	// The QR remains the tiled ground of the sculpture as it opens up.
	const floor = new THREE.InstancedMesh(
		new THREE.BoxGeometry(cell, sceneConfig.qr.tileHeight, cell),
		new THREE.MeshStandardMaterial({ roughness: sceneConfig.qr.roughness }),
		starts.length,
	);
	floor.name = "qr-ground";
	floor.receiveShadow = true;
	world.add(floor);
	const tile = new THREE.Object3D();
	for (let i = 0; i < starts.length; i++) {
		tile.position.set(starts[i].x, sceneConfig.qr.tileY, starts[i].z);
		tile.updateMatrix();
		floor.setMatrixAt(i, tile.matrix);
	}
	// Shuffle the starting pixels deterministically to distribute the morph across the QR.
	for (let i = starts.length - 1; i > 0; i--) {
		const j =
			(i * sceneConfig.sculpture.shuffleMultiplier +
				sceneConfig.sculpture.shuffleOffset) %
			(i + 1);
		[starts[i], starts[j]] = [starts[j], starts[i]];
	}
	const count = Math.max(starts.length, destinations.length);
	const pixels = new THREE.InstancedMesh(
		new THREE.BoxGeometry(1, 1, 1),
		new THREE.MeshStandardMaterial({
			roughness: sceneConfig.sculpture.roughness,
		}),
		count,
	);
	pixels.name = "contact-sculpture";
	pixels.instanceMatrix.setUsage(THREE.DynamicDrawUsage);
	pixels.castShadow = sceneConfig.shadows.enabled;
	pixels.receiveShadow = false;
	pixels.frustumCulled = false;
	world.add(pixels);
	const dummy = new THREE.Object3D(),
		color = new THREE.Color(),
		ink = new THREE.Color(palette.ink);
	const destinationColors = destinations.map((d) => new THREE.Color(d.color));
	const white = new THREE.Color(palette["qr-paper"]),
		stone = new THREE.Color(palette["scene-base"]);
	const groundInk = new THREE.Color(palette["scene-qr"]);
	floor.material.color.copy(ink);

	return {
		starts,
		cell,
		floor,
		count,
		pixels,
		dummy,
		color,
		ink,
		destinationColors,
		white,
		stone,
		groundInk,
	};
}
